module.exports = __webpack_public_path__ + "img/elementwidths_jas.b868a7f5.png";